module.exports = __webpack_public_path__ + "static/media/logo-treezor.4fb2c911.svg";